import { render, staticRenderFns } from "./btn-arrow-primary.vue?vue&type=template&id=603343ce&scoped=true&"
import script from "./btn-arrow-primary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-arrow-primary.vue?vue&type=style&index=0&id=603343ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603343ce",
  null
  
)

export default component.exports